import type { SVGProps } from "react";
export interface AnthropicLogoIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AnthropicLogoIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AnthropicLogoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill="#D97757"
        d="m5.923 15.3 3.936-2.207.066-.191-.066-.107h-.192l-.658-.04-2.248-.061-1.95-.081-1.89-.101-.475-.102L2 11.823l.046-.293.4-.268.572.05 1.266.086 1.899.13 1.377.082 2.04.212h.325l.046-.131-.11-.081-.087-.081-1.965-1.33-2.127-1.407-1.115-.81-.602-.41-.304-.385-.13-.84.546-.602.735.05.188.05.744.573 1.59 1.23 2.075 1.527.304.252.121-.086.015-.06-.136-.229-1.13-2.04L7.38 4.939l-.536-.86-.142-.515a2.5 2.5 0 0 1-.086-.607l.622-.845L7.582 2l.83.11.35.304.516 1.18.836 1.857 1.297 2.526.379.749.203.693.075.212h.131V9.51l.107-1.423.197-1.746.192-2.248.066-.633.313-.758.623-.41.486.232.4.572-.056.37-.237 1.544-.466 2.419-.304 1.62h.177l.203-.203.82-1.088 1.377-1.721.608-.683.709-.754.455-.36h.86l.633.941-.283.972-.886 1.123-.735.952-1.053 1.417-.658 1.133.06.091.157-.015 2.38-.506 1.286-.232 1.534-.263.694.324.076.329-.273.673-1.64.405-1.925.385-2.866.678-.035.025.04.05 1.291.122.553.03h1.352l2.517.187.658.434.394.532-.066.405-1.013.516-1.367-.324-3.19-.759-1.094-.272h-.15v.09l.91.89 1.671 1.508 2.092 1.944.107.48-.269.38-.283-.04-1.838-1.383-.71-.622-1.605-1.351h-.107v.142l.37.541 1.954 2.936.102.9-.142.293-.507.177-.556-.102-1.144-1.605-1.18-1.807-.952-1.62-.117.067-.562 6.048-.263.309-.608.232-.506-.385-.269-.622.269-1.23.324-1.604.263-1.276.238-1.584.142-.527-.01-.035-.116.015-1.195 1.64-1.818 2.455-1.438 1.539-.344.136-.597-.309.055-.552.334-.491 1.99-2.531 1.2-1.568.776-.906-.005-.131h-.046l-5.287 3.431-.942.121-.405-.379.05-.622.192-.203 1.59-1.093-.006.006z"
      />
    </svg>
  );
}
